var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flavor-content"},[_c('div',{staticClass:"title"},[_vm._v("Flavor")]),_c('van-list',{staticClass:"flavor-list"},_vm._l((_vm.flavorList),function(item,index){return _c('FlavorItem',{key:index,attrs:{"flavor":item,"select":index === _vm.value},nativeOn:{"click":function($event){return _vm.onFlavorChange(index)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }